
import actionType from "./actionTypes";
import axios from "axios";
import { toast } from "react-toastify";
import { getByLocation, patientRegisterService, InitialStatusNull } from "../patient/action"
import { saveRegisteredData } from "../facility/action";
import { fedexStatusChange, faxStatusChange, downloadStatusChange } from "../employee/action";

import URL from "../../assets/config";
 

export const LoginService = (payload, email) => dispatch => {
  dispatch(showIsLoading());
  toast.dismiss();
  const config = {
    method: 'post',
    url: URL.common.LOGIN,
    data: payload,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      "Authorization": 'Basic ' + btoa('epaper-client:epaper-secret'),
    }
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch(InitialStatusNull());
      dispatch(ProfileService(res.data.access_token, email));
      dispatch({
        type: actionType.LOGIN_SUCCESS,
        payload: res.data


      });
      localStorage.setItem("refresh_token", res.data.refresh_token);
    } else if (res.status === 206) {
      toast.error("Login Failed");
      dispatch({
        type: actionType.LOGIN_FAILURE,
      })
    }
    if (res.error_description) {
      toast("Incorrect Username or Password Please Try Again");
    }


  }).catch(error => {

    dispatch(hideIsLoading());
    if (error.message === "Network Error") {
      toast(error.message + ", Please contact admin");
    }
    else if (error){
      toast("Incorrect Username or Password Please Try Again");
    }


     dispatch({
      type: actionType.LOGIN_FAILURE,
     });
  });
};


export const emailValidService = (userType, email, mobile, formdata) => dispatch => {
  toast.dismiss();

  const config = {
    method: 'post',
    url: URL.common.EMAIL_VALID,
    data: email,

  };
  axios(config).then((res) => {
    if (res.status === 200) {

      dispatch(mobileValid(userType, mobile, formdata));
      dispatch({
        type: actionType.EMAIL_VALID_SUCCESS,
        payload: res.data.access_token

      });
    } if (res.status === 206) {
      toast.warning("Email already exist, try another")
      dispatch({
        type: actionType.EMAIL_VALID_FAILURE,
      })

    }
  }).catch(error => {

    dispatch({
      type: actionType.EMAIL_VALID_FAILURE,
      error: error
    });
  });
};

export const mobileValid = (userType, mobile, formdata) => dispatch => {
  toast.dismiss();

  const config = {
    method: 'post',
    url: URL.common.MOBILE_VALID,
    data: mobile,

  };
  axios(config).then((res) => {
    if (res.status === 200) {
      switch (userType) {
        case "patient":
          dispatch(patientRegisterService(formdata));
          break;
        case "facility":
          dispatch(saveRegisteredData(formdata));
          break;
        case "other":
          dispatch(patientRegisterService(formdata));
          break;
      }

      dispatch({
        type: actionType.MOBILE_VALID_SUCCESS,

      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.MOBILE_VALID_FAILURE,
      })
      toast.warning("Mobile number already exist, try another")

    }
  }).catch(error => {
    dispatch({
      type: actionType.MOBILE_VALID_FAILURE,
      error: error
    });
  });
};

export const ProfileService = (token, username, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());
  const config = {
    method: 'get',
    url: URL.common.PROFILE + username,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      if (res.data.commonUser.userType == "patient" || res.data.commonUser.userType == "other") {
        if (res.data.commonUser.registrationStatus == "Pending") {
          toast.error("Please confirm your email verification to login")
        } else {

          dispatch({
            type: actionType.PROFILE_SUCCESS,
            payload: res.data
          });

        }
      }
      else if (res.data.commonUser.userType == "facility") {
        if (res.data.commonUser.registrationStatus == "pending") {
          toast.error("Your registration still in pending, once Approved by Admin you can able to login ")
        } else {

          dispatch({
            type: actionType.PROFILE_SUCCESS,
            payload: res.data
          });

        }
      } else {

        dispatch({
          type: actionType.PROFILE_SUCCESS,
          payload: res.data
        });

      }


    } else if (res.status === 206) {
      dispatch({
        type: actionType.PROFILE_FAILURE,
      })
      // toast.error("Login Failed");
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(ProfileService, username))
    }
    
    //toast.error("Login Failed");
    dispatch({
      type: actionType.PROFILE_FAILURE,
      error: error
    });
  });
};
export const ChangePasswordService = (token, payload, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.common.CHANGEPASSWORD,
    data: payload,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };

  axios(config).then((res) => {
    dispatch(hideIsLoading());

    if (res.status === 200) {
      dispatch(logoutUser())
      dispatch({
        type: actionType.CHANGEPASSWORD_SUCCESS,
        message: res.data.message
      });
      toast.success(res.data.message)
    } else if (res.status === 206) {
      dispatch(hideIsLoading());
      dispatch({
        type: actionType.CHANGEPASSWORD_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)
    }
  }).catch(error => {
     dispatch(hideIsLoading());

     if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(ChangePasswordService, payload))
    }
    dispatch({
      type: actionType.CHANGEPASSWORD_FAILURE,
      error: error
    });
  });
};

export const EditProfileService = (token, payload, employeePayLoad, facilityPayload, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  let urlType;
  let payLoadDetails;

  if (payload.userType === "admin" || payload.userType === "employee") {
    urlType = URL.common.EDITADMINPROFILE
    payLoadDetails = employeePayLoad
  } else if (payload.userType === "facility") {
    urlType = URL.common.EDITPROFILE
    payLoadDetails = facilityPayload
  } else {
    urlType = URL.common.EDITPROFILE
    payLoadDetails = payload
  }


  const config = {
    method: 'put',
    url: urlType,
    data: payLoadDetails,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };


  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch(ProfileService(token, payload.email))
      dispatch({
        type: actionType.EDITPROFILE_SUCCESS,
        payload: res.data
      });
      toast.success(res.data.message);

    } else if (res.status === 206) {
      dispatch({
        type: actionType.EDITPROFILE_FAILURE,
      })
      toast.error(res.data.message);

    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(EditProfileService, payload, employeePayLoad, facilityPayload))
    }
    dispatch({
      type: actionType.EDITPROFILE_FAILURE,
      error: error
    });
  });
};


export const ForgotPasswordService = payload => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.common.FORGOTPASSWORD,
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    }
  };

  axios(config).then((res) => {
    if (res.status === 200) {
      dispatch(hideIsLoading());

      dispatch({
        type: actionType.FORGOTPASSWORD_SUCCESS,
        payload: payload.username,
        message: res.data.message
      });
      toast.success(res.data.message)
    } else if (res.status === 206) {
      dispatch(hideIsLoading());
      dispatch({
        type: actionType.FORGOTPASSWORD_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    dispatch({
      type: actionType.FORGOTPASSWORD_FAILURE,
      error: error
    });
    toast.error(error.response.data.message)
  });
};


export const resendVerificatonEmail = email => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.common.RESEND_VERIFY_EMAIL,
    data: {"username":  email},
    headers: {
      'Content-Type': 'application/json',
    }
  };

  axios(config).then((res) => {
    if (res.status === 200) {
      dispatch(hideIsLoading());

      dispatch({
        type: actionType.RESEND_VERIFY_EMAIL_SUCCESS,
         message: res.data.message
      });
      toast.success(res.data.message)
    } else if (res.status === 206) {
      dispatch(hideIsLoading());
      dispatch({
        type: actionType.RESEND_VERIFY_EMAIL_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    dispatch({
      type: actionType.RESEND_VERIFY_EMAIL_FAILURE,
      error: error
    });
   });
};




export const RandomPassword = payload => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.common.RANDOMPASSWORD,
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    }
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {

      dispatch({
        type: actionType.RANDOMPASS_SUCCESS,
        payload: res.data
      });
      toast.success(res.data.message);

    } else if (res.status === 206) {
      dispatch({
        type: actionType.RANDOMPASS_FAILURE,
      })
      toast.error(res.data.message);

    }
  }).catch(error => {
    dispatch(hideIsLoading());
    dispatch({
      type: actionType.RANDOMPASS_FAILURE,
      error: error
    });
  });
};

export const NewPassword = payload => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());
  const config = {
    method: 'post',
    url: URL.common.NEWPASSWORD,
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    }
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.NEWPASS_SUCCESS,
        payload: res.data
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.NEWPASS_FAILURE,
      })
      toast.error(res.data.message);
    }
  }).catch(error => {
    toast.error(error.response.data.message)
    dispatch(hideIsLoading());
    dispatch({
      type: actionType.NEWPASS_FAILURE,
      error: error
    });
  });
};


export const getNpiDetails = (payLoad) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.common.GET_NPI_DATA,
    data: payLoad,
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.GET_NPI_DATA_SUCCESS,
        payload: res.data,
        message: res.data.message
      });

    } else if (res.status === 206) {


      toast.warning("We tried fetching your data using " + payLoad.number + " No data found, Please enter manually")

      dispatch({
        type: actionType.GET_NPI_DATA_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    dispatch({
      type: actionType.GET_NPI_DATA_FAILURE,
      error: error
    });
  });
};



//contact Servuce call
export const ContactService = (payload) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.common.CONTACTSERVICEURL,
    data: payload,

  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      // toast.success("Send successfully")

      dispatch({
        type: actionType.CONTACT_SUCCESS,
        message: res.data.message
      });
      // toast.success(res.data.message);
    } else if (res.status === 206) {

      dispatch({
        type: actionType.CONTACT_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message);
    }
  }).catch(error => {
    dispatch(hideIsLoading());

    dispatch({
      type: actionType.CONTACT_FAILURE,
      error: error
    });
    toast.error(error.response.data.message)
  });
};






export const viewRequestInfo = (token, payload, ) => dispatch => {

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.common.VIEWREQUESTINFO,
    data: payload,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };

  axios(config).then((res) => {
    if (res.status === 200) {
      dispatch(hideIsLoading());
      dispatch(fedexStatusChange());
      dispatch(faxStatusChange());
      dispatch(downloadStatusChange());
      dispatch({
        type: actionType.VIEWREQUESTINFO_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.VIEWREQUESTINFO_FAILURE,
        error: res.data.message
      })
      // toast.error(res.data.message)
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(viewRequestInfo, payload))
    }
    dispatch({
      type: actionType.VIEWREQUESTINFO_FAILURE,
      error: error
    });
  });
};

export const updateNoteinRequest = (token, payload, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'put',
    url: URL.common.UPDATE_NOTE,
    data: payload,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };

  axios(config).then((res) => {
        dispatch(hideIsLoading());
      toast.success(res.data.message);
    if (res.status === 200 ) {
         let data = {
            requestId: payload.requestId
        }
      dispatch(viewRequestInfo(token, data ))
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(updateNoteinRequest, payload))
    }
  });
};




export const verifyRegister = (email) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.common.VERIFY_REGISTER,
    data: email,
    headers: {
      'Content-Type': "application/json",
    }
  };

  axios(config).then((res) => {
    if (res.status === 200) {
       dispatch(hideIsLoading());
      toast.success(res.data.message)

      dispatch({
        type: actionType.VERIFY_REGISTER_SUCCESS,
        message: res.data.message,
      });
    } else if (res.status === 206) {
      dispatch(hideIsLoading());
      dispatch({
        type: actionType.VERIFY_REGISTER_FAILURE,
        message: res.data.message
      })
       toast.error(res.data.message)
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    dispatch({
      type: actionType.VERIFY_REGISTER_FAILURE,
      message: error
    });
  });
};







export const viewAPIStatusChange = () => dispatch => {
  dispatch({
    type: actionType.VIEW_STATUS_CHANGE
  });

};







export const showIsLoading = () => {
  return {
    type: actionType.SHOW_IS_LOADING
  };
};

export const hideIsLoading = () => {
  return {
    type: actionType.HIDE_IS_LOADING
  };
};
export const logoutUser = () => dispatch => {
  dispatch({
    type: actionType.LOGOUT_USER
  });
};


export const sessionExpireFalseStatus = () => dispatch => {
  dispatch({
    type: actionType.SESSION_EXPIRE_FALSE
  });
};
 


export const refreshApiService = (callback, x, y, z, o) => dispatch => {
  let refresh_token = localStorage.getItem("refresh_token");

  const formData = new FormData();
  formData.append('grant_type', "refresh_token")
  formData.append('refresh_token', refresh_token)
 
  const config = {
    method: 'post',
    url: URL.common.LOGIN,
    data: formData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      "Authorization": 'Basic ' + btoa('epaper-client:epaper-secret'),
    }
  };

  axios(config).then((res) => {
    if (res.status === 200) {
      dispatch(hideIsLoading());
      dispatch(callback(res.data.access_token, x, y, z, o))
      dispatch({
        type: actionType.REFRESH_ACCESS_TOKEN_SUCCESS,
        payload: res.data.access_token,
        message: res.data.message
      });
    }
 
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_grant" || error.response.data.error == "invalid_token"){
         dispatch({
        type: actionType.SESSION_EXPIRED
      });
    }

  });
}

export const termsEmail = (payload) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.common.TERMS_EMAIL,
    data: payload,

  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      toast.success("email send successfully")
    } else if (res.status === 206) {
      toast.error("email not send ");
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    toast.error("email not send ");

  });
};


